import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getApplicationAvailableColumns } from './api';

export const path = '/uso-application/list';

const PageUsoApplications: React.FC = (props) => {
  const Page = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getApplicationAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <Page {...props} />;
};

export default PageUsoApplications;
